import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

function FaqPage() {
  const { t } = useTranslation();
  usePageTitle(t("faq.pageTitle"));

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <h1 className="legal-title">{t("faq.heroTitle")}</h1>
          <p className="legal-subtitle">{t("faq.heroSubtitle")}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("faq.q1")}</h2>
            <p>{t("faq.a1")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("faq.q2")}</h2>
            <p>
              {t("faq.a2Prefix")} <b>{t("faq.a2Time")}</b>.
            </p>
          </section>

          <section className="legal-section">
            <h2>{t("faq.q3")}</h2>
            <p>{t("faq.a3")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("faq.q4")}</h2>
            <p>
              {t("faq.a4Prefix")} <b>{t("faq.a4Server")}</b>. {t("faq.a4Suffix")}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t("faq.q5")}</h2>
            <p>{t("faq.a5")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("faq.q6")}</h2>
            <p>{t("faq.a6")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default FaqPage;
